import React from 'react';
import PropTypes from 'prop-types';
import { FlagBlock } from 'anf-core-react';

const StoreAddress = ({
  addressLine,
  city,
  stateOrProvinceName,
  postalCode,
  countryCode,
  country,
  telephone,
  isCity,
  isState,
  isPostalCode,
  isCountry,
  isPhone,
  paymentsAcceptedSpecificCountry,
}) => {
  let currentCity;
  let currentState;
  let currentPostalCode;
  let currentCountryFlag;
  let currentTelephone;

  if (isCity || isState || isPostalCode) {
    if (isCity) {
      currentCity = `${city} `;
    }
    if ((isState && countryCode === 'US')) {
      currentState = `${stateOrProvinceName} `;
    }
    if (isPostalCode) {
      currentPostalCode = `${postalCode}`;
    }
    currentCountryFlag = (
      <FlagBlock countryCode={countryCode}>
        {country}
      </FlagBlock>
    );
    if (isPhone) {
      currentTelephone = `${telephone}`;
    }
  }

  return (
    <>
      <p className="single-store__info-address" itemProp="address" itemScope itemType="http://schema.org/PostalAddress">
        {addressLine}
        <meta itemProp="streetAddress" content={addressLine} />
        <br />
        {currentCity}
        <meta itemProp="addressLocality" content={currentCity} />
        {currentState}
        <meta itemProp="addressRegion" content={stateOrProvinceName} />
        {currentPostalCode}
        <meta itemProp="postalCode" content={currentPostalCode} />
        {currentCountryFlag}
        {isCountry ? (
          <meta itemProp="addressCountry" content={countryCode} />
        ) : null}
        {currentTelephone}
        <meta itemProp="telephone" content={currentTelephone} />
      </p>
      <meta itemProp="paymentAccepted" content={paymentsAcceptedSpecificCountry} />
      <meta itemProp="priceRange" content="$$" />
      <meta itemProp="image" content="https://img.abercrombie.com/is/image/anf/LOGO_STACKED.png" />
    </>
  );
};

StoreAddress.defaultProps = {
  telephone: '',
};

StoreAddress.propTypes = {
  addressLine: PropTypes.string.isRequired,
  city: PropTypes.string.isRequired,
  stateOrProvinceName: PropTypes.string.isRequired,
  postalCode: PropTypes.string.isRequired,
  countryCode: PropTypes.string.isRequired,
  country: PropTypes.string.isRequired,
  telephone: PropTypes.string,
  isCity: PropTypes.bool.isRequired,
  isState: PropTypes.bool.isRequired,
  isPostalCode: PropTypes.bool.isRequired,
  isCountry: PropTypes.bool.isRequired,
  isPhone: PropTypes.bool.isRequired,
  paymentsAcceptedSpecificCountry: PropTypes.string.isRequired,
};

export default StoreAddress;
